import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { ReposComponent } from './components/repos/repos.component';
import { UserComponent } from './components/user/user.component';

@NgModule({
  declarations: [
    HomeComponent,
    ReposComponent,
    UserComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
  ],
  exports: [
    HomeComponent
  ]
})
export class SharedModule { }
